var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    x: 0.5,
    y: 3.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD6020",
    d: "M9.756 18.973 22.974 14.9v2.523a1.55 1.55 0 0 1-1.55 1.55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.448 9.454c.727 0 1.127.342 1.127.989.036.495-.291.913-.727.99l.981 1.408h-.763l-.836-1.37h-.073v1.37h-.618V9.454zm-.291 1.56h.182c.4 0 .581-.19.581-.533 0-.304-.181-.495-.581-.495h-.182zm-2.763 1.827h1.745v-.571h-1.127v-.914h1.09v-.57h-1.09v-.762h1.127v-.57h-1.745zm-1.818-1.104-.837-2.283h-.654l1.345 3.463h.328l1.345-3.463h-.655zm-7.38-.57c0 .95.726 1.75 1.635 1.75.291 0 .546-.076.8-.19v-.762c-.182.229-.436.38-.727.38A1.05 1.05 0 0 1 8.85 11.28v-.076c-.037-.609.436-1.142 1.018-1.18.29 0 .581.153.763.38v-.76c-.218-.152-.509-.19-.763-.19-.946-.077-1.673.723-1.673 1.712m-1.128-.42c-.364-.152-.473-.228-.473-.418.037-.229.218-.419.437-.38.181 0 .363.113.509.266l.327-.457c-.255-.228-.582-.38-.91-.38-.508-.039-.944.38-.98.913v.038c0 .457.181.723.763.913.145.038.29.114.436.19.11.077.182.19.182.343 0 .266-.218.495-.436.495h-.037a.72.72 0 0 1-.654-.457l-.4.419c.218.418.654.647 1.09.647.582.038 1.055-.419 1.091-1.028v-.114c-.036-.457-.218-.685-.945-.99m-2.109 2.094h.618V9.454H4.96zM2.087 9.454h1.091c.872.038 1.563.799 1.527 1.712 0 .495-.218.951-.582 1.294-.327.266-.727.419-1.127.38h-.91zm.8 2.816c.29.038.618-.076.836-.267.218-.228.327-.533.327-.875 0-.304-.109-.609-.327-.837a1.12 1.12 0 0 0-.836-.267h-.182v2.246z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD6020",
    fillRule: "evenodd",
    d: "M12.485 9.375c-.909 0-1.672.761-1.672 1.75 0 .952.727 1.751 1.672 1.79.946.037 1.673-.762 1.71-1.751-.037-.99-.764-1.789-1.71-1.789",
    clipRule: "evenodd"
  })));
};
export default SvgDiscover;